import { render, staticRenderFns } from "./EvolutionMainNumberOpinion.vue?vue&type=template&id=1a5e3204&scoped=true&lang=pug"
import script from "./EvolutionMainNumberOpinion.vue?vue&type=script&lang=js"
export * from "./EvolutionMainNumberOpinion.vue?vue&type=script&lang=js"
import style0 from "./EvolutionMainNumberOpinion.vue?vue&type=style&index=0&id=1a5e3204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e3204",
  null
  
)

export default component.exports